export const getters = {
	paymentMethods: state => state.paymentMethods,
	clientSecret: state => state.clientSecret
}



// WEBPACK FOOTER //
// ./src/common/store/PaymentMethod/getters.js